import { useState, useRef, useEffect } from "react";
import { Sparkles } from "lucide-react";
import { CATEGORIES } from "@/data/menu";
import { PizzaCard, BeverageCard } from "./ItemCard";

export const Menu = ({ onRequestAdd, onAddBeverage, onOpenMeioMeio }) => {
  const [activeId, setActiveId] = useState(CATEGORIES[0].id);
  const tabsRef = useRef(null);
  const active = CATEGORIES.find((c) => c.id === activeId);

  useEffect(() => {
    const el = tabsRef.current?.querySelector(`[data-tab-id="${activeId}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [activeId]);

  return (
    <section className="relative z-10 px-5 mt-2" data-testid="menu-section">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="font-display text-2xl text-zinc-50">Cardápio</h2>
        <span className="text-[11px] tracking-widest uppercase text-zinc-500">
          {active.items.length} itens
        </span>
      </div>

      {/* Meio a Meio CTA */}
      <button
        onClick={onOpenMeioMeio}
        data-testid="open-meio-meio-btn"
        className="press w-full mb-3 flex items-center justify-between gap-3 px-4 py-3 rounded-2xl border border-rose-600/40 bg-gradient-to-r from-rose-600/15 via-rose-600/10 to-transparent"
      >
        <span className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-full bg-rose-600/20 border border-rose-600/40 flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-rose-400" />
          </span>
          <span className="text-left">
            <span className="block text-sm font-semibold text-zinc-100">Monte sua Meio a Meio</span>
            <span className="block text-[11px] text-zinc-400">2 sabores · cobramos pelo mais caro</span>
          </span>
        </span>
        <span className="text-rose-400 text-xs font-bold uppercase tracking-widest">Montar</span>
      </button>

      {/* Tabs */}
      <div
        ref={tabsRef}
        className="no-scrollbar -mx-5 px-5 flex gap-2 overflow-x-auto pb-2 sticky top-0 z-20 bg-background/85 backdrop-blur-md py-3"
        data-testid="category-tabs"
      >
        {CATEGORIES.map((c) => {
          const isActive = c.id === activeId;
          return (
            <button
              key={c.id}
              data-tab-id={c.id}
              data-testid={`tab-${c.id}`}
              onClick={() => setActiveId(c.id)}
              className={`shrink-0 text-xs font-semibold px-4 py-2 rounded-full border transition-all press ${
                isActive
                  ? "bg-rose-600 border-rose-600 text-white shadow-[0_4px_16px_-4px_rgba(244,63,94,0.6)]"
                  : "bg-zinc-900/70 border-zinc-800 text-zinc-400"
              }`}
            >
              {c.label}
            </button>
          );
        })}
      </div>

      <div className="mt-3 flex flex-col gap-3" data-testid={`items-${active.id}`}>
        {active.items.map((it) =>
          active.type === "pizza" ? (
            <PizzaCard key={it.name} item={it} categoryId={active.id} onRequestAdd={onRequestAdd} />
          ) : (
            <BeverageCard key={it.name} item={it} categoryId={active.id} onAddBeverage={onAddBeverage} />
          )
        )}
      </div>
    </section>
  );
};
